import React from 'react'
import {
  View,
  TouchableHighlight,
  StyleSheet,
  ScrollView,
  TouchableOpacity
} from 'react-native'
import LinearGradient from 'react-native-linear-gradient'
import Text from '../../../components/Text'
import { connect } from 'react-redux'
import Icon from 'react-native-vector-icons/Ionicons'
import variables from '../../../assets/stylesheets/variables'
import { openWebBrowser } from '../../../utils'
import LottieContainer from '../../../components/LottieContainer'

import baseStyle from '../../../assets/stylesheets/layouts/base'
import { liens } from './liens'

class LiensUtiles extends React.Component {
  constructor() {
    super()
    this.liens = liens
  }

  goToLink = (url) => {
    openWebBrowser(url)
  }

  componentDidMount() {
    if (!this.props.route.params?.openWithId) {
      return
    }

    const linkToGoTo = this.liens.find(link => link.id === this.props.route.params?.openWithId)

    if (linkToGoTo) {
      this.goToLink(linkToGoTo.url)
    }
  }

  render() {
    const isInTab = this.props.route.name === 'HomeLiensUtiles'

    return (
      <View style={baseStyle.baseLayout}>
        <LinearGradient style={baseStyle.contentSection}
                        colors={variables.bgGradient}>
          <ScrollView style={styles.body}
                      contentContainerStyle={styles.contentContainerStyle}
                      alwaysBounceVertical={false}>
            {!isInTab &&
              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 32 }}>
                <TouchableOpacity activeOpacity={0.8}
                                  style={{ padding: 10 }}
                                  onPress={() => this.props.navigation.goBack()}>
                  <Icon style={{ marginTop: 2 }}
                        name="chevron-back"
                        size={24}
                        color={variables.colorDarkGray} />
                </TouchableOpacity>
                <Text style={{
                  fontSize: 18,
                  fontFamily: variables.fontFamily.semiBold
                }}>Liens utiles</Text>
              </View>
            }
            {this.liens.map((item, index) => (
              <TouchableHighlight key={index}
                                  style={styles.itemContainer}
                                  underlayColor={variables.colorHoverItem}
                                  activeOpacity={0.9}
                                  onPress={() => this.goToLink(item.url)}>
                <View style={{ flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontSize: 13 }}>
                      {item.label}
                    </Text>
                    <Text style={{ marginTop: 10, fontSize: 12, fontFamily: 'OpenSans-Semibold' }}>
                      {item.recommandation.label} {item.recommandation.flag}  -  {item.date}
                    </Text>
                  </View>
                  <Icon style={{ marginLeft: 20 }}
                        name="chevron-forward"
                        color={variables.primaryColor}
                        size={18} />
                </View>
              </TouchableHighlight>
            ))}
          </ScrollView>
        </LinearGradient>
        <LottieContainer primary
                         lottieAnimation={require('../../../assets/lottie/data-analysis.json')} />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  body: {
    zIndex: 1000,
    width: '100%',
    height: '100%',
    paddingHorizontal: 10
  },
  contentContainerStyle: {
    paddingVertical: 15
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 20,
    borderRadius: 4,
    shadowColor: 'rgba(0, 0, 0, 0.05)',
    shadowOpacity: 1,
    shadowRadius: 16,
    marginBottom: 14
  }
})

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(LiensUtiles)
